import AssignmentsListPage from '@/pages/assignments/list'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventAssignmentsPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <AssignmentsListPage portalMode="event" />
    </WorkspacePortalProvider>
  )
}
